import React from "react";
import WidgetBase from "./WidgetBase";
import { ErrorBoundary } from "react-error-boundary";

export function createWidget(dataSegment, ui, viewportData, createChildWidgetFunction, writeBackFunction, doActionFunction, startWorkFunction, getAutocompleteSuggestionsFunction, getContextActions) {
  if (!ui) return "no ui definition";
  let widgetType = ui.widgetType;
  if (!widgetType) return "no widget type";
  let component = loadWidgetComponent(widgetType) || loadWidgetComponent("Missing");

  const ErrorComponent = () => {
    let component = loadWidgetComponent("Error");
    return (
      <WidgetBase
        WidgetComponent={component}
        ui={ui}
        viewportData={viewportData}
      />
    );
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorComponent}>
      <WidgetBase
        WidgetComponent={component}
        ui={ui}
        viewportData={viewportData}
        dataSegment={dataSegment}
        createChildWidget={createChildWidgetFunction}
        writeBack={writeBackFunction}
        doAction={doActionFunction}
        startWork={startWorkFunction}
        getAutocompleteSuggestions={getAutocompleteSuggestionsFunction}
        getContextActions={getContextActions}
      />
    </ErrorBoundary>
  );
}

function loadWidgetComponent(widgetType, subFolder = "./widgets/") {
  try {
    let fullWidgetName = widgetType + "Widget";
    let file = require("" + subFolder + fullWidgetName);
    return file[fullWidgetName] || file.default;
  }
  catch (e) {
    console.log("Could not find Widget in '" + subFolder + "' for type", widgetType);
    return null;
  }
}
